import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import Mresult from '../Assets/Dewali_campaign/M_result.png'
import giftBoxes from '../Assets/Dewali_campaign/multiple_gift_box.png'
import popupbg from '../Assets/Dewali_campaign/popupbg.png'

import amazon from '../Assets/Dewali_campaign/giftcards/amazon (2).png'
import jio from '../Assets/Dewali_campaign/giftcards/jio.png'
import Zomato from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Zomato.png'
import Domions from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Domions.png'
import Flipkart from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Flipkart.png'
import AJIO from '../Assets/Dewali_campaign/giftcards/giftcards_logos/AJIO.png'
import PVR from '../Assets/Dewali_campaign/giftcards/giftcards_logos/PVR Cinemas.png'
import Prestige from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Prestige Smart Kitchen.png'
import Reliance from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Reliance Trends.png'
import Uber from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Uber giftcard.png'
import Bookmyshow from '../Assets/Dewali_campaign/giftcards/giftcards_logos/Bookmyshow.png'
import lifestyle from '../Assets/Dewali_campaign/giftcards/lifestyle.png'
import myntra from '../Assets/Dewali_campaign/giftcards/myntra.png'
import nykaa from '../Assets/Dewali_campaign/giftcards/nykaa.png'
import ssbeauty from '../Assets/Dewali_campaign/giftcards/ssbeauty.png'
import reliance from '../Assets/Dewali_campaign/giftcards/reliance.png'
import shoppersstop from '../Assets/Dewali_campaign/giftcards/shoppers.png'
import blinkit from '../Assets/Dewali_campaign/giftcards/blinkit.png'
import { makeApiCallWithAuth } from "../Services/Api";
import { Snackbar, Alert } from '@mui/material';

const brands = [ 
 { 
    id: 8767, 
    name: "Amazon", 
    giftcardName: "Amazon Shopping Voucher", 
    SKU: "EGVASVWHB2C001", 
    logo: amazon 
  },
  { 
    id: 13798, 
    name: "Flipkart", 
    giftcardName: "Flipkart E-Gift Card", 
    SKU: "EGVFK002", 
    logo: Flipkart 
  },
  { 
    id: 130, 
    name: "PVR", 
    giftcardName: "PVR Inox Cinemas E-Gift Card", 
    SKU: "EGVGBPVRC001", 
    logo: PVR 
  },
  { 
    id: 8212, 
    name: "Reliance Trends", 
    giftcardName: "Reliance Trends E-Gift Card", 
    SKU: "EGCGBREL005", 
    logo: Reliance 
  },
  { 
    id: 6860, 
    name: "Zomato", 
    giftcardName: "Zomato E-Gift Card", 
    SKU: "EGCGBZOMA001", 
    logo: Zomato 
  },
  { 
    id: 5404, 
    name: "AJIO", 
    giftcardName: "AJIO E-Gift Card", 
    SKU: "EGCGBAJIORRL001", 
    logo: AJIO 
  },
  { 
    id: 1474, 
    name: "Dominos", 
    giftcardName: "Dominos E-Gift Card", 
    SKU: "EGCGBDMNS011", 
    logo: Domions 
  },
  { 
    id: 3566, 
    name: "Nykaa", 
    giftcardName: "Nykaa E-Gift Card", 
    SKU: "EGCGBNYKA004", 
    logo: nykaa 
  },
  { 
    id: 1183, 
    name: "Uber", 
    giftcardName: "Uber E-Gift Card", 
    SKU: "EGCGBUBER001", 
    logo: Uber 
  },
  { 
    id: 14088, 
    name: "Blinkit", 
    giftcardName: "Blinkit B2C E-Gift Card", 
    SKU: "EGCGBBLINK002", 
    logo: blinkit
  }
];

const DiwaliGiftCard = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [openToast, setOpenToast] = useState(false);


  const handleOpen = (brand) => {
    setSelectedBrand(brand);
    setOpen(true);
  };

  const handleClose = () => {
    if(loading){
      console.log("waiting")
    }
    else{
    setOpen(false);
    setSelectedBrand(null);
    }
  };

    const handleClaim = async() => {
        try {
        setLoading(true)
        const response = await makeApiCallWithAuth('mailme',{
          'productId':selectedBrand?.id,
          'productName':selectedBrand?.giftcardName,
          'productSku':selectedBrand?.SKU
          // 'productId':324,
          // 'productName':"API TESTING - CN & PIN",
          // 'productSku': "CNPIN"
      });
        const res = response.data
        console.log(res)
      if (res.status === 200) {
            navigate('/purchase-details',{state:{selectedBrand:selectedBrand}})
      }else if (res.status == 400){
        setOpenToast(true)
        setTimeout(()=>{
          setOpenToast(false)
        },3000)
        setError(res.message)
      } else {
        setOpenToast(true)
        setTimeout(()=>{
          setOpenToast(false)
        },3000)
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setOpenToast(true)
      setTimeout(()=>{
        setOpenToast(false)
      },3000)
      setError("Failed to submit. Please try again.");
    } finally {
      setLoading(false)
      setOpen(false);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto text-center h-[100vh] overflow-auto rounded-2xl p-6 flex flex-col items-center gap-4 relative z-10 bg-[linear-gradient(to_right,rgba(255,170,1,0.9)_0%,rgba(255,130,27,0.5)_50%,rgba(239,135,0,0.9)_100%)] md:bg-[linear-gradient(to_right,rgba(255,170,1,0)_0%,rgba(255,130,27,0)_50%,rgba(239,135,0,0)_100%)]"  style={{scrollbarWidth: "none", OverflowStyle: "none",  }}>
  <div className="flex flex-col items-center z-10">
    <div className="w-32 h-32">
      <img
        src={giftBoxes}
        alt="User"
        className="w-full h-full object-cover"
      />
    </div>

    <h2 className="text-[30px] font-extrabold mt-4 text-dark">
      Claim Your Gift
    </h2>
    <p className="text-lg text-dark font-medium">
      Choose your{" "}
      <span className="md:text-[#E59F37] font-bold">
        ₹2,000 gift voucher
      </span>{" "}
      from one of the options below and enjoy a festive shopping experience.

    </p>
  </div>

  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 w-full mt-4 z-20">
    {brands.map((brand, index) => (
      <button
        key={index}
        onClick={() => handleOpen(brand)}
        className="bg-white rounded-xl shadow-sm p-3 flex justify-center items-center hover:scale-105 transition-transform duration-200 pointer-events-auto z-20"
      >
        <img
          src={brand.logo}
          alt={brand.name}
          className={`max-h-16 object-cover ${brand.name == 'Amazon' ? 'p-5' : ''}`}
        />
      </button>
    ))}
  </div>

 <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: '!rounded-2xl p-4',
        style:{
            background:
            `url(${popupbg}) no-repeat center bottom / cover`,
            
        }
          
      }}
    >
      <div className="absolute rounded-2xl top-2 right-2">
        <IconButton onClick={handleClose}>
          <CloseIcon className="text-gray-500" />
        </IconButton>
      </div>

      <div className="text-center text-lg font-bold p-2 mt-4 text-white">
        Confirm your Selection
      </div>

      <div className="flex flex-col items-center gap-4 px-6 pb-4 text-center -mt-1">
        <p className="text-sm text-white">
         You’ve selected <span className="">{selectedBrand?.name}</span> voucher worth ₹2,000
        </p>

        {selectedBrand?.logo && (
          <img
            src={selectedBrand.logo}
            alt={selectedBrand.name}
            className={`w-52 h-auto object-contain px-8 py-2 rounded-xl bg-white ${selectedBrand.name == 'Amazon' ? 'py-5 ' : ''}`}
          />
        )}
      </div>

      <DialogActions className="flex flex-col gap-2 px-6 pb-4">
        <Button
          fullWidth
          variant="contained"
          onClick={handleClaim}
          disabled={loading}
          sx={{
            backgroundColor: '#080C15',
            borderRadius: '9999px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#1e293b',
            },
          }}
        >
             {loading ? (
        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        ) : (
          'Claim Now'
        )}
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={handleClose}
          sx={{
            color: '#fff',
            borderColor: '#fff',
            borderRadius: '9999px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#fff',
              borderColor: '#fff',
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
         <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
  </div>
  );
};

export default DiwaliGiftCard;
